export default __webpack_public_path__ + "static/media/la-brands-400.3a8109c4.woff2";